import { MRT_PaginationState } from "material-react-table";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useSearchParams } from "react-router";
import { PAGINATION_ITEMS_PER_PAGE, PAGINATION_PAGE } from "src/_Globals/urls";
import { urlToNumber } from "src/_Globals/urls/urlToType/urlToNumber";
import { ApiPagination } from "src/api/_common/params/useApiPaginationUrlSync";

type GridPaginationInner = {
    pageIndex: number;
    pageSize: number;
};

export const APP_EMPTY_PAGINATION = {
    page: 1,
    itemsPerPage: 20,
} as const;

const urlToMrtPagination = (options: {
    page: string | null;
    itemsPerPage: string | null;
    // defaultValue: ApiPagination;
}): GridPaginationInner => {
    const { page, itemsPerPage } = options;

    const safePage = urlToNumber(page, APP_EMPTY_PAGINATION.page);
    const safeItemsPerPage = urlToNumber(itemsPerPage, APP_EMPTY_PAGINATION.itemsPerPage);

    return {
        // From Page, to PageIndex
        pageIndex: safePage - 1,
        pageSize: safeItemsPerPage,
    };
};

export type ExtendedGridPagination = GridPagination & {
    totalItems: number | undefined;
};
export type GridPagination = {
    pagination: MRT_PaginationState;
    setPagination: Dispatch<SetStateAction<MRT_PaginationState>>;
};

type GridPaginationUrlSyncOptions = {
    // I probably want args common to a URL system;
    // Instead of relying on API-type
    defaultValue: ApiPagination;
};
export const useGridPaginationUrlSync = (options?: GridPaginationUrlSyncOptions): GridPagination => {
    const { defaultValue } = options || {};

    const [searchParams, setSearchParams] = useSearchParams();
    const pageSearchParam = defaultValue?.page ?? searchParams.get(PAGINATION_PAGE);
    const itemsPerPageSearchParam = defaultValue?.itemsPerPage ?? searchParams.get(PAGINATION_ITEMS_PER_PAGE);

    const initialPagination = urlToMrtPagination({
        page: pageSearchParam,
        itemsPerPage: itemsPerPageSearchParam,
        // defaultValue,
    });

    const [pagination, setPagination] = useState<MRT_PaginationState>(initialPagination);

    useEffect(() => {
        // Kilian:
        // This is only to SET values;
        // If we want to UNSET defaults, it should be done in another central place.
        const newPaginationParams = new URLSearchParams(searchParams);

        if (pagination.pageIndex !== initialPagination.pageIndex) {
            const indexToPage = pagination.pageIndex + 1;
            newPaginationParams.set(PAGINATION_PAGE, indexToPage.toString());
        }

        if (pagination.pageSize !== initialPagination.pageSize) {
            newPaginationParams.set(PAGINATION_ITEMS_PER_PAGE, pagination.pageSize.toString());
        }

        if (newPaginationParams.toString() === searchParams.toString()) return;

        setSearchParams(newPaginationParams);
    }, [pagination]);

    return { pagination, setPagination };
};
